module.exports = __webpack_public_path__ + "img/Variant2.2f38aee8.png";